// estrae i dati dagli oggetti dei file .js
// e crea l'opportuna sintassi JSX utilizzata poi
// dal componente: "ProjectComp.jsx"
import React  from 'react'

function handlePreview(el){
    console.log(el.currentTarget)
}

function extractProjectTitle(ArrayIn){

    const title = ArrayIn.map((pTitle, idx) =>{
        return (
            <h1 key={pTitle} className='projTitle'>
                {
                    pTitle.proTitle
                }
            </h1>
        )
    })
return title
}
    
    
function extractProjectProps(ArrayIn, setGetproj, proType){

    const propsObj = ArrayIn.map((propsProj, idx) =>{
        return propsProj.projectProps
    })
    
    const propJSX = propsObj.map((props, idx) =>{
        const allPropsProjs = props.map((projProps, idx1) =>{
            return(
                    <section  
                                key={idx1} 
                                className='projPropsBox' 
                                param-type={proType} 
                                param-proj={idx1} 
                                onClick={ (event) => {
                                    setGetproj({proName: event.currentTarget.getAttribute("param-type"), 
                                                  proId: event.currentTarget.getAttribute("param-proj")})
                                }}
                    >
                        <React.Fragment>
                            <div className='projPropTitle'>
                                { projProps.title }
                            </div>
                            <div className='projContainerImg'>
                                <img src={ './' + projProps.img } alt="" />
                            </div>
                            <div className='projDesc'>
                                { projProps.desc }
                            </div>
                        </React.Fragment>
                    </section>
            )
    
        })
        return allPropsProjs;
    })
    return propJSX
}
    

const MakeComponent = ({titleSection, propsSection}) =>{

    const cObj = (
            <section className='proj_main_container'>
                <div className="projsContainer">
                        <div>
                            { titleSection }
                        </div>
                        <div className="projProps">
                            { propsSection }
                        </div>
                </div>    
            </section>
    )


    return(
        cObj
    )

}
    

export { extractProjectTitle }
export { extractProjectProps }
export { MakeComponent }